import { AutogenLayoutLMEUserTemplates } from "./autogen/AutogenLayoutLMEUserTemplates";
import { LookupModelSearchEvent } from "@mcleod/components";

export class LMEUserTemplates extends AutogenLayoutLMEUserTemplates {
    textboxConfTemplateBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = 'Z';
        event.filter.template_number = ">0";
    }

    textboxQuoteTemplateBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = 'Q';
        event.filter.template_number = ">0";
    }

    textboxLtlQuoteTemplateBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = 'Y';
        event.filter.template_number = ">0";
    }
}
